export default {

    getQuoteRequestStatus: {
        method: 'get',
        url: '/dashboard/sales/status-quote-request'
    },
    getDataQuoteRequestStatus: {
        method: 'get',
        url: '/dashboard/sales/data-status-quote-request?status=STATUS'
    },

    getQuoteStatus: {
        method: 'get',
        url: '/dashboard/sales/status-quote'
    },
    getDataQuoteStatus: {
        method: 'get',
        url: '/dashboard/sales/data-status-quote?status=STATUS'
    },

    timelyAlertCreationTrackingOperation: {
        method: 'get',
        url: '/dashboard/sales/time-alert-creation-tracking-operation'
    },
    dataTimelyAlertCreationTrackingOperation: {
        method: 'get',
        url: '/dashboard/sales/data-time-alert-creation-tracking-operation?type=TYPE'
    }
}
